import { makeStyles } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    padding: '24px',
  },
  progressContainer: {
    marginTop: '16px',
    marginBottom: '24px',
    position: 'relative',
    width: '100%',
    height: '4px',
  },
  progressTrack: {
    position: 'absolute',
    width: '100%',
    height: '4px',
    backgroundColor: '#e1dfdd',
    borderRadius: '2px',
  },
  progressFill: {
    position: 'absolute',
    height: '4px',
    backgroundColor: '#0078d4',
    borderRadius: '2px',
    transition: 'width 0.3s ease',
  },
});